module.exports = __webpack_public_path__ + "static/img/5.1efa4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/5.png
// module id = X0cr
// module chunks = 1